export const START_COUNTDOWN = 3000;
export const START_QUIZ = 5000;
export const BRAND_STROKE_WIDTH = 3; // Default line thickness for axes and other lines to match 2020 brand guidelines
